import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Router from 'vue-router'
Vue.use(Router)

//将这段代码添加到你的index.js中即可
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
router.afterEach((to,from,next) => {

  window.scrollTo(0,0);

// 或

// window.scroll(0, 0);

});
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
